import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import {
  quotationValidationSchema,
  initialValues,
} from "./quotationValidationSchema";
import "./QuotationForm.css";
import { stateOptions } from "../../../MIS/Globdata";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { decrypt } from "../../../MIS/encryption";
import { handleChangeCheckBox, handleItemAmountChange, handleQuotationFormUpdate, loadPartyOptions, loadProductOptions, useLoadQuotation } from "./quotationFormModel";
import useToast from "../../../API/GlobalHooks/useToast";
import { useModal } from "../../ConfirmationModal/ModalContext";

const CustomFloatingInput = ({ name, label, as = "input", ...props }) => (
  <div className="custom-floating">
    <Field
      name={name}
      as={as}
      className="form-control form-control-sm"
      placeholder=" "
      {...props}
    />
    <label htmlFor={name}>{label}</label>
    <ErrorMessage name={name} component="div" className="text-danger small" />
  </div>
);

const QuotationForm = () => {
  const navigate=useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const showToast = useToast();
  const { showModal } = useModal();
  const decrypted_id = decrypt(decodeURIComponent(id));
  const [isChecked, setIsChecked] = useState(false);
  const [quotation, setQuotation] = useState({});  
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const isReadOnly = location.pathname.includes("/admin/quotation/view");
  
  useLoadQuotation({id:decrypted_id,setQuotation,setLoading, showToast,
    isReadOnly
  });


  const calculateTotals = (items) => {
    const subtotal = items.reduce(
      (acc, item) =>
        acc + parseFloat(item.item_qty || 0) * parseFloat(item.item_rate || 0),
      0
    );
    const gst = subtotal * 0;
    // const sgst = gst / 2;
    // const cgst = gst / 2;
    const sgst = 0;
    const cgst = 0;
    const grandTotal = subtotal + gst;
     

    return { subtotal, sgst, cgst, grandTotal };
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  return (
    <>

    <div className="quotation-wrapper container-fluid border rounded shadow-sm p-0">
      <Formik
        enableReinitialize      
        initialValues={{
          ...initialValues,
          quote_date: getTodayDate(),
          quote_no: "",
          ...(quotation && Object.keys(quotation).length > 0 ? quotation : {}),
        }}
        validationSchema={quotationValidationSchema}
        onSubmit={async (values, { setSubmitting, validateForm }) => {              
          handleQuotationFormUpdate({values,showToast,setSubmitLoading,navigate})
        }}
      >
        {({ values, setFieldValue, resetForm }) => {
          const { subtotal, sgst, cgst, grandTotal } = calculateTotals(
            values.details
          );

          const handleReset = () => {
            if (window.confirm("Are you sure you want to reset the form?")) {
              resetForm({
                values: {
                  ...initialValues,
                  quote_date: getTodayDate(),
                  quote_no: "",
                },
              });
            }
          };

          return (
          <Form id="quotation-form">
            <div
              className="quotation-header d-flex justify-content-between align-items-center px-4 py-2 border-bottom bg-white sticky-top"
              style={{ top: 0, zIndex: 1050 }}
              >
                <h5 className="m-0 text-primary">Quotation</h5>
                <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
                  {/* Accept Checkbox */}
                  <div className="form-check mb-0">
                    <Field
                      type="checkbox"
                      name="quote_status"
                      className="form-check-input"
                      id="quote_status"
                      checked={
                        Object.keys(quotation).length > 0 ?
                        quotation?.quote_status === 1 ? true 
                        : quotation?.quote_status === 2 ? false :isChecked
                        :  isChecked} // Bind checkbox state to isChecked        
                      onChange={(e)=>{
                        handleChangeCheckBox(isChecked,setIsChecked)
                        if(isChecked){
                          if(quotation?.quote_status===0){
                           setFieldValue('quote_status',0)
                           
                          }else{
                           setFieldValue('quote_status',2)
                          
                          }
                        }else{
                          setFieldValue('quote_status',1)
                          
                        }
                      }}
                    />
                    <label className="form-check-label ms-1" 
                    htmlFor="quote_status">
                      Accept
                    </label>
                  </div>

                  {/* Submit Button */}
                  <button type="submit" 
                  className="btn btn-success btn-sm">
                  {submitLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      <>Submit</>
                    )}                    
                  </button>

                  {/* Close Button */}
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => navigate("/admin/quotation-list")}
                  >
                    Close
                  </button>
                </div>
              </div>
              {loading ? (
              <>
              <div className='d-flex justify-content-center align-items-center'>
                <span
                  className="text-primary spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                  style={{ width: '2rem', height: '2rem' }}
                ></span>
                </div>
              </>
             ):(
              <div className="quotation-form-scroll p-4">
                <div className="row mb-4">
                  <div className="col-md-8">
                    <div className="row g-2">
                      <div className="col-md-6">
                      <AsyncSelect
                          cacheOptions
                          defaultOptions
                          loadOptions={loadPartyOptions}
                          name="pid"
                          value={
                            values.pid
                              ? { value: values.pid, label: values.party_name }
                              : null
                          }
                          onChange={(option) => {
                            if (option) {
                              setFieldValue("pid", option.value);
                              setFieldValue("party_name", option.label);
                              setFieldValue("party_mob", option.mob);
                              setFieldValue("party_state", option.state);
                              setFieldValue("party_city", option.city);
                              setFieldValue("party_pinCode", option.postalCode);
                              setFieldValue("party_address", option.address);
                            }
                          }}
                          isClearable
                          classNamePrefix="select"
                          placeholder="Select party"
                        />
                        <ErrorMessage
                          name="pid"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                      <div className="col-md-6">
                        <CustomFloatingInput name="party_mob" 
                          label="Mobile"
                          inputMode="numeric"
                          maxLength="10"
                          onInput={e => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                        />
                      </div>
                      <div className="col-md-4">
                        <Select
                          options={stateOptions}
                          name="party_state"
                          value={stateOptions.find(
                            (opt) => opt.value === values.party_state
                          )}
                          onChange={(option) =>
                            setFieldValue("party_state", option.value)
                          }
                          classNamePrefix="select"
                          placeholder="Select State"
                        />
                      </div>
                      <div className="col-md-4">
                        <CustomFloatingInput name="party_city" label="City" />
                      </div>
                      <div className="col-md-4">
                        <CustomFloatingInput
                          name="party_pinCode"
                          label="Postal Code"
                          inputMode="numeric"
                          maxLength="6"
                          onInput={e => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                        />
                      </div>
                      <div className="col-md-12">
                        <CustomFloatingInput
                          name="party_address"
                          label="Address"
                          as="textarea"
                          rows="2"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <CustomFloatingInput name="quote_no" label="Quotation No" />
                    <CustomFloatingInput
                      name="quote_date"
                      type="date"
                      label="Date"
                    />
                  </div>
                </div>

                <div className="table-responsive mb-3">
                  <FieldArray name="details">
                    {({ push, remove }) => (
                      <table className="table table-bordered table-sm item-table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "30%" }}>Particular</th>
                            <th style={{ width: "12%" }}>HSN</th>
                            <th style={{ width: "12%" }}>Size</th>
                            <th style={{ width: "12%" }}>Qty</th>
                            <th style={{ width: "12%" }}>Rate</th>
                            <th style={{ width: "12%" }}>Amount</th>
                            <th style={{ width: "10%" }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.details.map((item, index) => (
                          <tr key={index}>
                            <td style={{ position: "relative", zIndex: 5 }}>
                            <AsyncSelect
                              cacheOptions
                              defaultOptions
                              loadOptions={loadProductOptions}
                              name={`details[${index}].item_name`}
                              value={
                                values.details[index].item_id
                                  ? { value: values.details[index].item_id, label: values.details[index].item_name }
                                  : null
                              }
                              onChange={(option) => {
                                if (option) {
                                  setFieldValue(`details[${index}].item_id`, option.id);
                                  setFieldValue(`details[${index}].item_main_id`, option.mpid);
                                  setFieldValue(`details[${index}].item_sub_id`, option.subid);
                                }
                              }}
                              isClearable
                              classNamePrefix="select"
                              placeholder="Select product"
                              
                              // 🟢 KEY FIXES BELOW
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 1040 })
                              }}
                            />

                                <ErrorMessage
                                  name={`details[${index}].item_name`}
                                  component="div"
                                  className="text-danger small"
                                />
                              </td>
                              <td>
                                <Field
                                  name={`details[${index}].item_hsn`}
                                  className="form-control form-control-sm"
                                />                                
                              </td>
                              <td>
                                <Field
                                  name={`details[${index}].item_size`}
                                  className="form-control form-control-sm"
                                />
                                <ErrorMessage
                                  name={`details[${index}].item_size`}
                                  component="div"
                                  className="text-danger small"
                                />
                              </td>
                              <td>
                                <Field
                                  name={`details[${index}].item_qty`}
                                  type="number"
                                  className="form-control form-control-sm"
                                  onChange={(e) => {
                                    const newQty = e.target.value;
                                    setFieldValue(`details[${index}].item_qty`, newQty);
                                    const rate = values.details[index].item_rate;
                                    handleItemAmountChange(setFieldValue, index, newQty, rate);
                                  }}
                                  
                                />
                                <ErrorMessage
                                  name={`details[${index}].item_qty`}
                                  component="div"
                                  className="text-danger small"
                                />
                              </td>
                              <td>
                                <Field
                                  name={`details[${index}].item_rate`}
                                  type="number"
                                  className="form-control form-control-sm"
                                  onChange={(e) => {
                                    const newRate = e.target.value;           
                                    setFieldValue(`details[${index}].item_rate`, newRate);                       
                                    const qty = values.details[index].item_qty;
                                    handleItemAmountChange(setFieldValue, index, qty, newRate);
                                  }}
                                />
                                <ErrorMessage
                                  name={`details[${index}].item_rate`}
                                  component="div"
                                  className="text-danger small"
                                />
                              </td>
                              <td className="text-end">
                                ₹{" "}
                                {(
                                  parseFloat(item.item_qty || 0) *
                                  parseFloat(item.item_rate || 0)
                                ).toFixed(2)}
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger me-1"
                                  onClick={() => remove(index)}
                                >
                                  &times;
                                </button>
                                {index === values.details.length - 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() =>
                                      push({
                                        quote_id: 0,
                                        item_main_id: 0,
                                        item_sub_id: 0,
                                        item_id: 0,
                                        item_name: "",
                                        item_hsn: "0",
                                        item_size: "",
                                        item_qty: "",
                                        item_mrp: "",
                                        item_rate: "",
                                        item_amount: "",
                                      })
                                    }
                                  >
                                    +
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </FieldArray>
                </div>

                <div className="row justify-content-end mb-4">
                  <div className="col-md-4">
                    <div className="p-3 border rounded bg-light">
                      <div className="d-flex justify-content-between mb-1">
                        <span>Subtotal:</span>
                        <span>₹{subtotal.toFixed(2)}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span>SGST (0%):</span>
                        <span>₹{sgst.toFixed(2)}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span>CGST (0%):</span>
                        <span>₹{cgst.toFixed(2)}</span>
                      </div>
                      <div className="d-flex justify-content-between fw-bold mt-2">
                        <span>Grand Total:</span>
                        <span>₹{grandTotal.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          )}
            </Form>
          );
        }}
      </Formik>
    </div>
    </>
  );
};

export default QuotationForm;
